import { Fragment, useCallback, useEffect, useState } from "react";
import SipDetails from "./Sip";
import Lumpsum from "./Lumpsum";
import LumpsumSip from "./LumpsumSip";
import {
  checkoutNewPurchase,
  getAmcMasters,
  getNewPurchaseFundList,
  storeSchemeDetails,
} from "../../../../store/actions";
import {
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  Box,
} from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import { useAppSelector } from "../../../../store/hooks";
import { useHistory, useLocation } from "react-router-dom";
import {
  AmcHeader,
  NewPurchaseSummary,
  SipSummaryItem,
} from "../../cart/CartItems";
import { InvestorHeader } from "../../cart/InvestorCart";
import CustomButton from "../../../forms/CustomButton";

const SchemeDetails = () => {
  const { state: routerState } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { cart } = useAppSelector((state) => state.newinvestor);
  const { cartItems } = useAppSelector((state) => state.cartReducer);

  const getFundDesc = function (fundCode) {
    const fund = funds.find(({ value }) => value.toString() === fundCode);
    return fund?.label || "";
  };

  const [funds, setFunds] = useState([]);
  const schemes = ["Lumpsum", "SIP", "Lumpsum + SIP"];
  const [scheme, setScheme] = useState("Lumpsum");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    (async function () {
      setFunds(await getAmcMasters()(dispatch));
    })();
  }, [dispatch]);

  const submitCart = async () => {
    if (routerState.transactionType === "NPL") {
      history.replace("/payment-options/new-purchase/cart", {
        requestBody: { ...routerState.requestBody, ...cart },
      });
      return;
    }
    const requestBody = {
      cartId: cartItems[0].cartId,
      pan: cartItems[0].pan,
      arnCode: cartItems[0].arnCode,
      selectedCartItems: routerState.selectedCartItems,
      newPurchaseSipType: routerState.newPurchaseSipType,
      ...cart,
    };
    if (routerState.transactionType === "SINI") {
      history.replace("/payment-options/sip-purchase-without-payment/cart", {
        requestBody: { ...requestBody, ...cart },
      });
      return;
    }
    if (routerState.transactionType === "SIN") {
      history.replace("/payment-options/sip-purchase-with-payment/cart", {
        requestBody: { ...requestBody, ...cart },
      });
      return;
    }
  };

  const submitSingle = () => {
    if (routerState.transactionType === "NPL") {
      history.replace("/payment-options/new-purchase/single", {
        requestBody: { ...routerState.requestBody, ...cart },
      });
      return;
    }
    if (routerState.transactionType === "SINI") {
      history.replace("/payment-options/sip-purchase-without-payment/single", {
        requestBody: { ...routerState.requestBody, ...cart },
      });
      return;
    }
    if (routerState.transactionType === "SIN") {
      history.replace("/payment-options/sip-purchase-with-payment/single", {
        requestBody: { ...routerState.requestBody, ...cart },
      });
      return;
    }
    history.replace("/payment-options", {
      requestBody: { ...cart, ...routerState.requestBody },
      isSingle: true,
      transactionType: routerState.transactionType,
      newPurchaseSipType: routerState.newPurchaseSipType,
    });
  };

  const isSip =
    ["SINI"].includes(routerState.transactionType) ||
    routerState.newPurchaseSipType === "SIPN";

  if (isSip && routerState.isSingle) {
    return (
      <Fragment>
        <InvestorHeader
          name={routerState.requestBody.investorName}
          pan={routerState.pan}
        />

        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
            marginBottom: "120px",
          }}
        >
          <AmcHeader amcName={getFundDesc(routerState.requestBody.fund)} />
          <Box
            sx={{
              padding: "10px",
              border: "0.5px solid #C7D2D4",
            }}
          >
            <Box padding={"10px"}>
              <SipSummaryItem {...routerState.requestBody} />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomButton
              label="Submit"
              variant="contained"
              onClick={submitSingle}
            />
          </Box>
        </Box>
      </Fragment>
    );
  }

  if (isSip && routerState.isCart) {
    const { selectedCartItems } = routerState;
    return (
      <Fragment>
        <InvestorHeader
          name={cartItems[0].investorName}
          pan={cartItems[0].pan}
        />

        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
            marginBottom: "120px",
          }}
        >
          <AmcHeader amcName={cartItems[0].payload.fmdesc} />
          <Box
            sx={{
              padding: "10px",
              border: "0.5px solid #C7D2D4",
            }}
          >
            <Box padding={"10px"}>
              {cartItems
                .filter((item) =>
                  selectedCartItems.some((id) => id === item.cartItemId)
                )
                .map((item) => (
                  <SipSummaryItem {...item.payload} />
                ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomButton
              label="Submit"
              variant="contained"
              onClick={submitCart}
            />
          </Box>
        </Box>
      </Fragment>
    );
  }

  if (routerState.transactionType === "NPL" && routerState.isSingle) {
    return (
      <Fragment>
        <InvestorHeader
          name={routerState.requestBody.investorName}
          pan={routerState.pan}
        />

        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
            marginBottom: "120px",
          }}
        >
          <AmcHeader amcName={getFundDesc(routerState.requestBody.fund)} />
          <Box
            sx={{
              padding: "10px",
              border: "0.5px solid #C7D2D4",
            }}
          >
            <Box padding={"10px"}>
              <NewPurchaseSummary {...routerState.requestBody} />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomButton
              label="Submit"
              variant="contained"
              onClick={submitSingle}
            />
          </Box>
        </Box>
      </Fragment>
    );
  }
  if (routerState.transactionType === "NPL" && routerState.isCart) {
    const { selectedCartItems } = routerState;
    return (
      <Fragment>
        <InvestorHeader
          name={cartItems[0].investorName}
          pan={cartItems[0].pan}
        />

        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
            marginBottom: "120px",
          }}
        >
          <AmcHeader amcName={cartItems[0].payload.fmdesc} />
          <Box
            sx={{
              padding: "10px",
              border: "0.5px solid #C7D2D4",
            }}
          >
            <Box padding={"10px"}>
              {cartItems
                .filter((item) =>
                  selectedCartItems.some((id) => id === item.cartItemId)
                )
                .map((item) => (
                  <NewPurchaseSummary {...item.payload} />
                ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomButton
              label="Submit"
              variant="contained"
              onClick={submitCart}
            />
          </Box>
        </Box>
      </Fragment>
    );
  }

  return (
    <>
      <div className="container-margin" style={{ marginBottom: "10px" }}>
        <span
          style={{ fontWeight: 900, marginTop: "12px" }}
          className="input-margin"
        >
          Mode of Transaction *
        </span>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="Search"
            name="search"
            value={scheme}
            style={{ flexDirection: "row" }}
            onChange={(e) => setScheme(e.target.value)}
          >
            {schemes.map((mode) => (
              <div
                className={`investor-radio-button input-margin-investor-flow dual-margin-investor-flow ${
                  scheme === mode ? "investor-active" : ""
                }`}
              >
                <FormControlLabel
                  value={mode}
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#033f7c" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">
                  {mode === "SIP" ? "SIP(Without Payment)" : mode}
                </div>
              </div>
            ))}
          </RadioGroup>
        </FormControl>
      </div>
      {scheme === "Lumpsum" ? <Lumpsum /> : ""}
      {scheme === "SIP" ? <SipDetails type="SIP"/> : ""}
      {scheme === "Lumpsum + SIP" ? <SipDetails type="Lumpsum + SIP"/> : ""}
    </>
  );
};

export default connect(null, { getNewPurchaseFundList, storeSchemeDetails })(
  SchemeDetails
);
